
import React from 'react';
import { Brain, Check } from 'lucide-react';

const DifferenceSection = () => {
  return (
    <section className="py-24 bg-gradient-to-b from-[#0D0D0D] to-[#0A0A0A] relative overflow-hidden">
      <div className="absolute inset-0 bg-[url('/images/grid.svg')] bg-center opacity-5"></div>
      
      <div className="container mx-auto px-4">
        <div className="flex flex-col lg:flex-row items-center lg:items-start gap-12 max-w-6xl mx-auto">
          {/* Text content - left side */}
          <div className="lg:w-1/2" data-aos="fade-right">
            <h2 className="text-3xl md:text-4xl font-bold font-future text-white mb-6">
              Was uns unterscheidet
            </h2>
            <div className="w-24 h-1 bg-gradient-to-r from-purple-900 to-blue-900 mb-8"></div>
            
            <div className="space-y-6">
              <div className="bg-black/30 backdrop-blur-sm rounded-lg p-6 border border-purple-900/20">
                <h3 className="text-xl font-semibold text-white mb-2">Klassische Videoagentur</h3>
                <ul className="space-y-2">
                  <li className="text-gray-400 flex items-start">
                    <span className="text-red-500 mr-2">✕</span> 
                    Teuer durch hohe Personalkosten
                  </li>
                  <li className="text-gray-400 flex items-start">
                    <span className="text-red-500 mr-2">✕</span> 
                    Langsame Produktion mit vielen Abstimmungsschleifen
                  </li>
                  <li className="text-gray-400 flex items-start">
                    <span className="text-red-500 mr-2">✕</span> 
                    Menschlich begrenzte Kapazitäten
                  </li>
                </ul>
              </div>
              
              <div className="bg-black/30 backdrop-blur-sm rounded-lg p-6 border border-purple-500/20">
                <h3 className="text-xl font-semibold text-purple-400 mb-2">Future Level</h3>
                <ul className="space-y-2">
                  <li className="text-gray-300 flex items-start">
                    <Check className="text-purple-500 mr-2 h-5 w-5 shrink-0" /> 
                    KI-basiert: Kosten reduziert, Qualität maximiert
                  </li>
                  <li className="text-gray-300 flex items-start">
                    <Check className="text-purple-500 mr-2 h-5 w-5 shrink-0" /> 
                    Modular aufgebaut für schnelle Anpassungen
                  </li>
                  <li className="text-gray-300 flex items-start">
                    <Check className="text-purple-500 mr-2 h-5 w-5 shrink-0" /> 
                    Lernfähige Systeme, die mit jedem Projekt besser werden
                  </li>
                  <li className="text-gray-300 flex items-start">
                    <Check className="text-purple-500 mr-2 h-5 w-5 shrink-0" /> 
                    Persönlicher Support trotz Automatisierung
                  </li>
                </ul>
              </div>
            </div>
          </div>
          
          {/* Visual content - right side */}
          <div className="lg:w-1/2 relative" data-aos="fade-left">
            <div className="rounded-2xl overflow-hidden relative aspect-video">
              <div className="absolute inset-0 bg-gradient-to-br from-purple-900/30 to-blue-900/30 backdrop-blur-sm"></div>
              <div className="absolute inset-0 flex items-center justify-center">
                <div className="relative">
                  <Brain className="w-24 h-24 text-purple-400 animate-pulse" />
                  <div className="absolute inset-0 bg-purple-500/20 blur-xl rounded-full animate-pulse"></div>
                </div>
              </div>
              <div className="absolute inset-0 bg-[url('/images/circuit-pattern.svg')] bg-center opacity-10"></div>
              
              {/* Animated lines */}
              <div className="absolute top-0 left-0 w-full h-full">
                <div className="absolute top-1/4 left-0 w-full h-[1px] bg-gradient-to-r from-transparent via-purple-500/50 to-transparent animate-scan-line"></div>
                <div className="absolute top-2/4 left-0 w-full h-[1px] bg-gradient-to-r from-transparent via-purple-500/50 to-transparent animate-scan-line animation-delay-1000"></div>
                <div className="absolute top-3/4 left-0 w-full h-[1px] bg-gradient-to-r from-transparent via-purple-500/50 to-transparent animate-scan-line animation-delay-2000"></div>
              </div>
            </div>
            <div className="text-center mt-6">
              <p className="text-gray-400 text-sm">KI-gestützte Videoerstellung revolutioniert die Branche</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default DifferenceSection;
